import { createReducer, Action, on } from '@ngrx/store';
import { State, initialState } from './state';
import * as actions from './actions';

const reducer = createReducer(
  initialState,
  on(actions.load, (state => {
    return {
      ...state,
      loading: true
    };
  })),
  on(actions.loadSuccess, ((state, { organization })  => {
    return {
      ...state,
      loading: false,
      data: organization
    };
  })),
  on(actions.loadFail, ((state, { error })  => {
    return {
      ...state,
      loading: false,
      error
    };
  })),
  on(actions.clear, ((state)  => {
    return initialState;
  })),
);

export function organizationReducer(state: State, action: Action) {
  return reducer(state, action);
}
